import t from './strings'

export const validators = {
  identification: value => {
    if (!value || value.length === 0) {
      return t.idNumberNotNull()
    }

    if (value.length > 0 && value.length < 9) {
      return t.idNumberProperLength()
    }

    return null
  },
}
